export default __webpack_public_path__ + "static/media/photo_default.e758b76e.png";